export default "__VITE_ASSET__BYNTZYSe__"